import { lazy as lazyLoad } from 'react';

import { route } from '../profile/constants';

import type { RouteDefinition } from '../../route';

const lazy = {
    EditAmbitionsPage: lazyLoad(async () => {
        const { EditAmbitions } = await import('./EditAmbitions');

        return { default: EditAmbitions };
    }),
};

export const routes: readonly RouteDefinition[] = [
    {
        documentTitle: 'pages.user-profile.ambitions-edit.headline',
        page: lazy.EditAmbitionsPage,
        path: route.patterns.individualUser.ambitions.edit,
    },
];
